import React, { useEffect, useState } from "react";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { useRoutes } from "react-router-dom";

import { Helmet, HelmetProvider } from "react-helmet-async";

import getRoutes from "./Routes";
import useAuthStore from "./Hooks/auth";
import { ToastContainer } from "react-toastify";
import ErrorBoundary from "./ErrorBoundary";

import { db } from './firebase';
import { getDoc, doc } from 'firebase/firestore'
import Maintenance from './Utils/Maintenance';

const Routes = () => {
  const { role } = useAuthStore();
  const routes = React.useMemo(() => getRoutes(role), [role]);
  return useRoutes(routes);
};

function App() {
  const [data, setdata] = useState(false);
  const docRef = doc(db, 'collegeConnectMaintenance', 'R4jgJQRAad2R4maGucIK');
  useEffect(() => {
    const getDatafromFS = async () => {
      try {
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setdata(docSnap.data().maintenanceFlag)
        } else {
          console.log("Document does not exist")
        }
      } catch (error) {
        console.error(error)
      }
    }
    getDatafromFS()
  }, [])

  return (
    <>
      <HelmetProvider>
        <Helmet titleTemplate="%s | " defaultTitle="College Dashboard"></Helmet>
      </HelmetProvider>
      <ErrorBoundary>
        {data ? (<Maintenance />) :
          (<Routes />)
        }
      </ErrorBoundary>
      <ToastContainer
        autoClose={3000}
        progressClassName="toastProgress"
        bodyClassName="toastBody"
      />
    </>
  );
}

export default App;
